import CryptoJS from 'crypto-js/crypto-js'
import store from '../../store'
export default {
  // inject: ['app'],
  data() {
    return {}
  },
  methods: {
    async get(name, model, callback) {
      if (!this.$http || !this.$http.api) {
        console.warn('$http not initialized')
        return
      }
      return this.$http.api
        .get(
          name,
          {
            params: model
          },
          {}
        )
        .then(response => {
          if (callback) {
            callback(response.data)
          }
        })
    },
    async post(name, model, callback, errorCallback) {
      if (!this.$http || !this.$http.api) {
        console.warn('$http not initialized')
        if (errorCallback) {
          errorCallback({ message: '$http not initialized' })
        }
        return
      }
      return this.$http.api.post(name, model).then(response => {
        if (callback) {
          callback(response.data)
        }
      }).catch(e => {
        if (errorCallback) {
          errorCallback(e.response)
        }
      })
    },
    // async postCPC (url, sessionId, StatusCode, StatusDesc, Message, EncryptData, CpcPostUrl, ChannelId, RequestId) {
    async postCPC(url, data) {
      const newForm = document.createElement('form')
      newForm.id = 'postForm'
      newForm.action = url
      newForm.target = '_self'
      newForm.method = 'post'
      // newForm.method = 'post'
      const input = document.createElement('input')

      for (let temp in data) {
        // console.log('temp : ', JSON.stringify(temp))
        input.name = data[temp].name
        input.type = 'hidden'
        input.value = data[temp].value
        newForm.appendChild(input.cloneNode())
      }
      document.body.appendChild(newForm)
      newForm.submit()
      document.body.removeChild(newForm)
    },
    download(name, model, callback) {
      if (!this.$http || !this.$http.download) {
        console.warn('$http not initialized')
        return
      }
      return this.$http.download
        .get(name, { params: model })
        .then(callback)
    },
    encrypt(word) {
      // return 'encryptTest'
      let aes1 = CryptoJS.enc.Utf8.parse(store.getters.getAes1)
      let aes2 = CryptoJS.enc.Utf8.parse(store.getters.getAes2)
      let srcs = CryptoJS.enc.Utf8.parse(word)
      return CryptoJS.AES.encrypt(srcs, aes1, { iv: aes2, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString()
    },
    decrypt(word) {
      let aes1 = CryptoJS.enc.Utf8.parse(store.getters.getAes1)
      let aes2 = CryptoJS.enc.Utf8.parse(store.getters.getAes2)
      let decrypt = CryptoJS.AES.decrypt(word, aes1, { iv: aes2, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
      return decrypt.toString(CryptoJS.enc.Utf8)
    },
    goErrorPage(msg) {
      if (msg) {
        this.$store.commit('routeTransfer/update', { msg })
      } else {
        this.$store.commit('routeTransfer/reset')
      }
      this.$router.push({ name: 'error' })
    }
  }
}
